import React, { Component } from 'react';
import { Popup } from 'semantic-ui-react';

interface HoverablePopupProps {
    flowing?: boolean;
    hoverable?: boolean;
    children?: React.ReactNode;
    trigger: React.ReactNode;
    content?: string;
    onClose?: () => void;
}

export default class HoverablePopup extends Component<HoverablePopupProps> {
    render() {
        return (
            <Popup mouseEnterDelay={500} mouseLeaveDelay={500} {...this.props}>
                {this.props.children}
            </Popup>
        );
    }
}
